import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import AccountUsers from "./user-accounts";
import Locations from "./locations";
import ContactPersons from "./contact-persons";
import { IContactPerson, IUserAccount } from "src/types/clients";
import { ILocation } from "src/types/locations";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomTabPanel, {
  a11yProps,
} from "src/shared/components/custom-tab-panel";

interface IProps {
  contactPersons: IContactPerson[];
  userAccounts: IUserAccount[];
  locations: ILocation[];
  refetch: Function;
  status: "archived" | "active";
  clientName: string;
}

const ClientProfileTabs = (props: IProps) => {
  const {
    contactPersons,
    userAccounts,
    locations,
    refetch,
    status,
    clientName,
  } = props;
  const isSmallScreen = useMediaQuery("(max-width:700px)");
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const currentPath = location.pathname;

  const isComingFromActiveClientsPage = currentPath.includes("active");
  const activeOrArchived = isComingFromActiveClientsPage ? "active" : "archived";
  // Map paths to tab indices
  const tabPaths = [
    `/clients/${activeOrArchived}/${id}/contacts`,
    `/clients/${activeOrArchived}/${id}/locationList`,
    `/clients/${activeOrArchived}/${id}/accounts`,
  ];
  // Find the tab index based on the current URL path
  const currentTabIndex = tabPaths.indexOf(currentPath);
  const [value, setValue] = useState(
    currentTabIndex === -1 ? 0 : currentTabIndex
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(tabPaths[newValue]); // Change the URL based on the selected tab
  };

  // Update the tab value when the URL changes
  useEffect(() => {
    const newTabIndex = tabPaths.indexOf(currentPath);
    if (newTabIndex !== value) {
      setValue(newTabIndex === -1 ? 0 : newTabIndex);
    }
  }, [currentPath]);

  return (
    <Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          // orientation={isSmallScreen ? "vertical" : "horizontal"}
          sx={{
            minHeight: { xs: "100%", md: "44px" },
            height: { xs: "100%", md: "44px" },
            bgcolor: "#232323",
            borderRadius: "10px",
          }}
        >
          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Contact Persons"}
            {...a11yProps(0)}
          />

          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Locations"}
            {...a11yProps(1)}
          />
          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Account Users"}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ContactPersons
          contactPersons={contactPersons}
          status={status}
          refetch={refetch}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Locations
          locations={locations}
          status={status}
          refetch={refetch}
          clientName={clientName}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AccountUsers
          userAccounts={userAccounts}
          status={status}
          refetch={refetch}
          locations={locations}
        />
      </CustomTabPanel>
    </Box>
  );
};

export default ClientProfileTabs;
